import script from "./project-with.vue?vue&type=script&lang=js&setup=true"
export * from "./project-with.vue?vue&type=script&lang=js&setup=true"

import "./project-with.vue?vue&type=style&index=0&id=43da2be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43da2be2"]])

export default __exports__